import React from 'react';
import SidebarBlock from '../SidebarBlock';
import DeviationSidebarGrid from '../DeviationSidebarGrid';
export var SimpleDeviationGridBlock = function (_a) {
    var parentDeviation = _a.parentDeviation, _b = _a.deviations, deviations = _b === void 0 ? [] : _b, streamKey = _a.streamKey, seeAll = _a.seeAll, titleOverride = _a.titleOverride, isLoading = _a.isLoading;
    if (!isLoading && !deviations.length) {
        return null;
    }
    return (React.createElement(SidebarBlock, { streamKey: streamKey, seeAll: isLoading ? undefined : seeAll, titleOverride: titleOverride, isLoading: isLoading },
        React.createElement(DeviationSidebarGrid, { streamId: "deviation-sidebar-" + streamKey + "-" + parentDeviation.deviationId, parentDeviation: parentDeviation, deviations: deviations, isLoading: isLoading })));
};
SimpleDeviationGridBlock.displayName = 'SimpleDeviationGridBlock';
export default SimpleDeviationGridBlock;
//# sourceMappingURL=SimpleDeviationGridBlock.js.map